
import { defineComponent, ref, reactive, toRefs, onMounted, watchEffect, computed, watch, nextTick } from 'vue'
import { SearchOutlined, CloseCircleFilled, DeleteOutlined } from '@ant-design/icons-vue'
import { askApi } from '@/api/index'
import Askcollapse from '@/components/asktheSecretary/askcollapse.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: {
    SearchOutlined,
    CloseCircleFilled,
    Askcollapse,
    DeleteOutlined,
    Nodata
  },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    navObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    }
  },
  setup(props: any, content: any) {
    const pageData: any = reactive({
      value: '',
      showInput: true,
      placeholder: '请输入代码/简拼/名称/关键词搜索问答',
      options: [],
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      historyData: JSON.parse(sessionStorage.getItem('askingHistory') || '[]') || [],
      historyOption: [],
      selectDisabled: false,
      searchstr: '',
      searchObj: {
        InstExt: [],
        KeyWords: []
      },
      tags: [],
      activeLi: '',
      activeindex: -1,
      showDropdown: false,
      width: 8 + 'px'
    })
    const askingselect = ref()
    function handleChange(e: any, value: any, option: any) {
      pageData.value = ''
      let obj = {}
      setWidth()
      // 标识----如果已经加入标签，则不需要再push
      let flag = false
      if (typeof value.Id === 'number') {
        // 如果有该属性，则证明是股票
        obj = value
        if ((pageData.searchObj.InstExt || []).map((item: any) => item.Id).indexOf(value.Id) < 0) {
          pageData.searchObj.InstExt.push(obj)
          flag = true
        }
      } else {
        if (pageData.searchObj.KeyWords.indexOf(value.Id) < 0) {
          pageData.searchObj.KeyWords.push(value.Id)
          flag = true
          obj = {
            value: value.Id,
            Id: value.Id,
            Code: value.Id
          }
        }
      }
      if (flag) {
        pageData.tags.push(obj)
        // askingselect.value.blur()
        pageData.historyData.push(obj)
      }
      search()
      e.stopPropagation()
      return false
      // pageData.value = ''
      // }
    }
    function searchValue(val: string) {
      if (!pageData.value) return
      pageData.searchstr = pageData.value
      const data: any = {}
      data.data = {
        markettype: ['CNX'],
        marketcode: 'sh,sz',
        key: pageData.value,
        active: false
      }
      data.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      askApi.searchStock(data).then((res: any) => {
        pageData.options = (res.Data || []).filter((item: any) => item.MarketCode === 'sh' || item.MarketCode === 'sz')
        // pageData.activeLi = pageData.options[0].Id
      })
    }
    pageData.selectOption = computed(() => {
      const history = pageData.historyOption
      const data = !pageData.searchstr.length && history.length ? history : pageData.options
      return data
    })
    pageData.firstActiveValue = computed(() => {
      if ((pageData.selectOption || []).length) {
        return [((pageData.selectOption || [])[0] || {}).Id]
      } else {
        return ''
      }
    })
    function handlefocusInput() {
      pageData.activeLi = ''
      pageData.activeindex = -1
      askingselect.value.focus()
    }
    function focusSelect() {
      pageData.showDropdown = true
      pageData.activeLi = ''
      pageData.activeindex = -1
      window.addEventListener('keydown', handlekeyFn, !0)
      let history = (JSON.parse(sessionStorage.getItem('askingHistory') || '[]') || []).reverse()
      // 去个重，且只取前10个
      const map = new Map()
      for (const i of history) {
        if (!map.has(i.Id)) {
          map.set(i.Id, i)
        }
      }
      history = [...map.values()]
      pageData.historyOption = history.splice(0, 10)
      pageData.options = history
      // pageData.options = []
    }
    // 失去焦点时去搜索
    function blurSelect() {
      setTimeout(() => {
        pageData.showDropdown = false
        if (!pageData.activeLi) {
          enterSelect()
        }
      }, 400)
    }
    function clickButton(e: any) {
      // 需要阻止冒泡事件
      e.stopPropagation()
      enterSelect()
      return false
    }
    function search() {
      if (!pageData.tags.length) return
      pageData.showDropdown = false
      pageData.value = ''
      setWidth()
      // 加入历史搜索

      handleFn()
      hanldeHistory()
      pageData.searchstr = ''
      if (pageData.tags.length >= 5) {
        pageData.selectDisabled = true
      }
      nextTick(() => {
        askingselect.value.blur()
      })
    }
    async function enterSelect() {
      if (!pageData.activeLi && !pageData.value.length) return
      setWidth()
      if (pageData.activeLi) {
        // 选中了下拉框里的内容
        let obj: any = []
        if (typeof pageData.activeLi === 'number') {
          // 股票
          obj = pageData.selectOption.filter((item: any) => item.Id === pageData.activeLi)
          pageData.searchObj.InstExt.push(...obj)
        } else if (typeof pageData.activeLi === 'string') {
          obj = [
            {
              value: pageData.activeLi.trim(),
              Id: pageData.activeLi.trim(),
              Code: pageData.activeLi.trim()
            }
          ]
        }
        pageData.tags.push(...obj)
      } else if (pageData.value.length) {
        // 无选中，要进行分词
        const data = pageData.searchObj.KeyWords.concat(pageData.searchObj.InstExt)
        // 在此处判断
        let flag = true
        if (pageData.searchstr.length) {
          // 如果当前 searchstr 已经作为股票添加到pageData.searchObj.InstExt，则不在作为关键词添加到 KeyWords
          pageData.searchObj.InstExt.some((item: any) => {
            if (item.Code === pageData.searchstr || item.Name === pageData.searchstr) {
              flag = false
              return false
            }
          })
          if (flag) {
            const arr = pageData.value.split(/[ ,，]/)
            const obj: any = []
            const obj1: any = []
            for (let i = 0; i < arr.length; i++) {
              const item = arr[i]
              const itemResult = await searchItem(item)
              // 分词后，需要查询分词后的字符串是否为股票，调一遍接口，如果Code 或Name 一致，则作为股票，
              if (itemResult.length && (itemResult[0].Code === item || itemResult[0].Name === item)) {
                //
                obj.push(itemResult[0])
                pageData.historyData.push(itemResult[0])
              } else {
                if (pageData.tags.map((item: any) => item.Id).indexOf(item) < 0 && item.trim() !== '') {
                  const _k = {
                    value: item.trim(),
                    Id: item.trim(),
                    Code: item.trim()
                  }
                  obj1.push(_k)
                  pageData.historyData.push(_k)
                }
              }
            }
            obj.length && pageData.searchObj.InstExt.push(...obj)
            obj1.length && pageData.searchObj.KeyWords.push(...obj1.map((item: any) => item.Code))
            pageData.tags.push(...obj, ...obj1)
            // pageData.value = ''
          }
        }
      }
      search()
      // askingselect.value.blur()
    }
    async function searchItem(item: string) {
      if (!item) return
      const data: any = {}
      data.data = {
        markettype: ['CNX'],
        // marketcode: 'sh,sz',
        key: item,
        active: false
      }
      data.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      return askApi.searchStock(data).then((res: any) => {
        const result = (res.Data || []).filter((item: any) => item.MarketCode === 'sh' || item.MarketCode === 'sz')
        return result || []
      })
    }
    function handleFn() {
      content.emit('changeObj', pageData.searchObj)
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    function selectValue(e: any, option: any) {}
    function deletetag(e: any, o: any) {
      if (typeof e === 'string') {
        // 关键词
        pageData.searchObj.KeyWords.splice(pageData.searchObj.KeyWords.indexOf(e), 1)
      } else {
        // 否则为股票
        pageData.searchObj.InstExt = pageData.searchObj.InstExt.filter((item: any) => {
          return item.Id !== e
        })
      }
      pageData.tags = pageData.tags.filter((item: any) => {
        return item.Id !== e
      })
      if (!pageData.tags.length) {
        content.emit('clearsearch')
      }
      handleFn()
    }
    function hanldeHistory() {
      if (pageData.historyData) {
        const history = JSON.parse(sessionStorage.getItem('askingHistory') || '[]') || []
        sessionStorage.setItem('askingHistory', JSON.stringify(pageData.historyData))
      }
    }
    watch(
      () => pageData.tags,
      () => {
        const len = pageData.tags.length
        pageData.selectDisabled = len >= 5 ? true : false
      }
    )
    // watch(
    //   () => pageData.value,
    //   (val: any) => {
    //     setWidth()
    //   }
    // )
    watch(
      () => props.navObj,
      () => {
        // 如果点了侧边栏，则清空
        cleartags()
      }
    )
    function setWidth() {
      nextTick(() => {
        if (!pageData.tags.length && !pageData.value.length) return
        const input: any = document.getElementById('askingInput')
        const maxWith = document.body.clientWidth - 230 - 150
        const span: any = document.querySelector('.placeholder')
        if (span.clientWidth < maxWith) {
          pageData.width = span.offsetWidth + 8 + 'px'
        }
      })
    }
    function clearHistory() {
      pageData.historyData = []
      pageData.historyOption = []
      pageData.showDropdown = false
      sessionStorage.removeItem('askingHistory')
    }
    function cleartags() {
      pageData.searchObj = {
        InstExt: [],
        KeyWords: []
      }
      // pageData.value = []
      pageData.tags = []
      handleFn()
    }
    function cleartagsCall() {
      content.emit('clearsearch')
    }
    function handlekeyFn(e: any) {
      if (e.code !== 'ArrowDown' && e.code !== 'ArrowUp') return
      // 向下箭头
      if (e.code === 'ArrowDown') {
        pageData.activeindex++
        if (pageData.activeindex >= pageData.selectOption.length) {
          pageData.activeindex = pageData.selectOption.length - 1
        }
        pageData.activeLi = pageData.selectOption[pageData.activeindex].Id
      } else if (e.code === 'ArrowUp') {
        pageData.activeindex--
        if (pageData.activeindex < 0) {
          pageData.activeindex = 0
        }
        pageData.activeLi = pageData.selectOption[pageData.activeindex].Id
      }
      const dom: any = document.querySelector('.searchlist')
      // const ul: any = document.querySelector('.selectul')
      // const _height = ul.offsetHeight()

      const optionsid = pageData.selectOption.map((item: any) => item.Id)
      const index = optionsid.indexOf(pageData.activeLi)
      if (pageData.activeindex < 10) {
        dom.scrollTop = 0
      } else {
        dom.scrollTop = pageData.activeindex * 32
      }
    }
    function inputKeyup(e: any) {
      if (e.code === 'Enter') {
        enterSelect()
      }
      setWidth()
    }
    // function enter() {
    //   if (!pageData.searchstr.length) {
    //     blurSelect()
    //   }
    // }
    return {
      ...toRefs(pageData),
      handleChange,
      searchValue,
      focusSelect,
      clearHistory,
      cleartags,
      blurSelect,
      deletetag,
      selectValue,
      cleartagsCall,
      askingselect,
      enterSelect,
      handlekeyFn,
      handlefocusInput,
      setWidth,
      clickButton,
      inputKeyup
    }
  }
})
